<template>
    <div class="container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-6">
                        <span>Crear línea de producción</span>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <form @submit.prevent="createProductionLine">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-2 mb-2">
                            <label for="code" class="form-label">Código</label>
                            <input v-model="formData.code" id="code" class="form-control" required />
                        </div>
                        <div class="col-12 col-sm-6 col-md-3 mb-2">
                            <label for="name" class="form-label">Nombre</label>
                            <input v-model="formData.name" id="name" class="form-control" required />
                        </div>
                        <div class="col-12 col-sm-12 col-md-5 mb-2">
                            <label for="descrip" class="form-label">Descripción</label>
                            <input v-model="formData.descrip" id="descrip" class="form-control" required />
                        </div>
                        <div class="col-12 col-sm-6 col-md-2 mb-2">
                            <label for="packaging_format_id" class="form-label">Formato por defecto</label>
                            <select v-model="formData.packaging_format_id" id="packaging_format_id" class="form-control" required>
                                <option disabled value="">Seleccione un formato</option>
                                <option v-for="format in packagingFormats" :key="format.id" :value="format.id">
                                    {{ format.descrip }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 col-sm-6 col-md-3 mb-2">
                            <label for="operator_count" class="form-label">Nº Operarios MMTO/AUX</label>
                            <input v-model="formData.operator_count" id="operator_count" class="form-control" required />
                        </div>
                        <div class="col-12 col-sm-6 col-md-3 mb-2">
                            <label for="salary" class="form-label">Salario bruto anual</label>
                            <input v-model="formData.salary" id="salary" class="form-control" required />
                        </div>
                        <div class="col-12 col-sm-6 col-md-3 mb-2">
                            <label for="micro_stops_min_time" class="form-label">Tiempo min. microparada (s)</label>
                            <input v-model="formData.micro_stops_min_time" id="micro_stops_min_time" class="form-control" required />
                        </div>
                        <div class="col-12 col-sm-6 col-md-3 mb-2">
                            <label for="micro_stops_max_time" class="form-label">Tiempo max. microparada (s)</label>
                            <input v-model="formData.micro_stops_max_time" id="micro_stops_max_time" class="form-control" required />
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 col-sm-6 col-md-2 mb-2">
                            <label for="target_oee" class="form-label">OEE Objetivo</label>
                            <input v-model="formData.target_oee" id="target_oee" class="form-control" required />
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 mb-2">
                            <label for="base_topic_name" class="form-label">Nombre base tópico</label>
                            <input v-model="formData.base_topic_name" id="base_topic_name" class="form-control" required />
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-2">
                            <label for="datalogger_id" class="form-label">Datalogger</label>
                            <select v-model="formData.datalogger_id" id="datalogger_id" class="form-control" required>
                                <option disabled value="">Seleccione un datalogger</option>
                                <option v-for="datalogger in dataloggers" :key="datalogger.id" :value="datalogger.id">
                                    {{ datalogger.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-end">
                        <button type="button" class="btn btn-danger me-2" @click="cancelProductionLineCreation">
                            Cancelar
                        </button>
                        <button type="submit" class="btn btn-success">
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <transition name="slide-fade">
            <ActionConfirmModal
                v-if="showActionConfirmModal"
                :contentMessage="actionConfirmModalMessage"
                :closeModal="closeActionConfirmModal"
                :methodForProp="methodForProp"
            />
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert} from "../../common/utils";
import ButtonComponent from "../../common/components/ButtonComponent.vue";
import Colors from "../../common/colors";
import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";

export default {
    name: "ProductionLineCreate",
    components: {
        ButtonComponent,
        ActionConfirmModal,
    },
    data() {
        return {
            formData: {
                code: "",
                name: "",
                descrip: "",
                target_oee: "",
                operator_count: "",
                salary: "",
                micro_stops_min_time: "",
                micro_stops_max_time: "",
                packaging_format_id: "",
                datalogger_id: "",
                topic_base_name: "",
            },
            packagingFormats: [],
            dataloggers: [],
            colors: Colors,
            showActionConfirmModal: false,
            actionConfirmModalMessage: "",
            methodForProp: null,
        };
    },
    methods: {
        createProductionLine() {
            axios.post("/api/production-line", this.formData)
                .then((response) => {
                    window.location.href = "/production-line";
                })
                .catch((error) => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
        },
        fetchPackagingFormats() {
            axios.get("/api/packaging-format/vue-data")
                .then((response) => {
                    this.packagingFormats = response.data.data.packagingFormats;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        fetchDataloggers() {
            axios.get("/api/datalogger")
                .then((response) => {
                    this.dataloggers = response.data;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        cancelProductionLineCreation() {
            this.actionConfirmModalMessage = "¿Está seguro de que desea cancelar la creación de la línea de producción?";
            this.methodForProp = () => {
                this.redirectToProductionLine();
            };
            this.openActionConfirmModal();
        },
        clearFormData() {
            this.formData = {
                code: "",
                name: "",
                descrip: "",
                target_oee: "",
                operator_count: "",
                salary: "",
                micro_stops_min_time: "",
                micro_stops_max_time: "",
                packaging_format_id: "",
                datalogger_id: "",
            };
        },
        redirectToProductionLine() {
            window.location.href = "/production-line";
        },
        openActionConfirmModal() {
            this.showActionConfirmModal = true;
        },
        closeActionConfirmModal() {
            this.showActionConfirmModal = false;
        },
    },
    mounted() {
        this.clearFormData();
        this.fetchPackagingFormats();
        this.fetchDataloggers();
    },
};
</script>

<style scoped></style>
